module.exports = __webpack_public_path__ + "16647b721934a44b6fbe3117a89e7817.svg";